import type {ProviderId} from '@smartmixin/core';

import AmbientWeatherLogo from '../../../assets/img/icon-ambient-weather-512.webp';
import DavisLogo from '../../../assets/img/icon-davis-512.webp';
import EcowittLogo from '../../../assets/img/icon-ecowitt-512.webp';
import MyAcuriteLogo from '../../../assets/img/icon-my-acurite-512.webp';
import NetatmoEnergyLogo from '../../../assets/img/icon-netatmo-energy-512.webp';
import NetatmoWeatherLogo from '../../../assets/img/icon-netatmo-weather-512.webp';
import TempestLogo from '../../../assets/img/icon-weatherflow-512.webp';
import WundergroundLogo from '../../../assets/img/icon-wunderground-512.webp';

/** The logo of each provider: the services list, its intro and its page. */
export const PROVIDER_LOGOS: Record<ProviderId, string> = {
  wunderground: WundergroundLogo,
  ecowitt: EcowittLogo,
  ambientWeather: AmbientWeatherLogo,
  davis: DavisLogo,
  weatherflow: TempestLogo,
  myAcurite: MyAcuriteLogo,
  netatmoWeather: NetatmoWeatherLogo,
  netatmoEnergy: NetatmoEnergyLogo,
};

/** The route segment of each provider under /app/settings/services/. */
export const PROVIDER_ROUTE_SLUG: Record<ProviderId, string> = {
  wunderground: 'wunderground',
  ecowitt: 'ecowitt',
  ambientWeather: 'ambient-weather',
  davis: 'davis',
  weatherflow: 'weatherflow',
  myAcurite: 'my-acurite',
  netatmoWeather: 'netatmo-weather',
  netatmoEnergy: 'netatmo-energy',
};

export const PROVIDER_FROM_SLUG: Record<string, ProviderId> =
  Object.fromEntries(
    Object.entries(PROVIDER_ROUTE_SLUG).map(([id, slug]) => [
      slug,
      id as ProviderId,
    ]),
  );

export const SERVICES_PATH = '/app/settings/services';
